module.exports = __webpack_public_path__ + "img/2018-12-28.cffb4c5e.jpg";